import { useAppRole } from "../../common/layout/useAppRole";
import { navRoleFor, useNavAccess } from "../../common/layout/useNavAccess";
import { filterHomeConfig, homeConfig } from "./homeConfig";
import { HomeLoading } from "./HomeLoading";
import { HomeShell } from "./HomeShell";

export const Home = () => {
  const { access, owned, resolving } = useNavAccess();
  const role = navRoleFor(useAppRole(), owned);
  if (resolving) return <HomeLoading />;
  return <HomeShell config={filterHomeConfig(homeConfig[role], access)} />;
};
